import { Box } from '@coolblue-development/becky';
import { Chip, Tooltip } from '@coolblue-development/freddy';
import { Attachment } from '../../../../../../models/Attachment';

const REMOVE_ATTACHMENT_TOOLTIP = 'To remove the attachment, delete this draft and start a new reply';

interface AttachmentChipsProps {
  attachments: Attachment[];
}

const AttachmentChips = ({ attachments }: AttachmentChipsProps): JSX.Element | null => {
  if (attachments.length === 0) {
    return null;
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: '8px',
        marginBottom: '12px'
      }}
      data-testid="attachment-chips-container"
    >
      {attachments.map(attachment => (
        <Tooltip key={attachment.id} description={REMOVE_ATTACHMENT_TOOLTIP} placement="top">
          <span tabIndex={0}>
            <Chip variant="button-dismissible" size="small" disabled data-testid={`attachment-chip-${attachment.id}`}>
              {attachment.name}
            </Chip>
          </span>
        </Tooltip>
      ))}
    </Box>
  );
};

export default AttachmentChips;
